<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <header-add
            v-if="isCreate()"
            :typeEvent="1"
            route="paymentcalendars/create"
          />
        </div>
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-2"
          />
          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
          >
            <template slot="addColumns">
              <table-column-badges
                prop="businesses[0].name"
                :label="$t('common_words.associated_companies2')"
                fromData="businesses"
                textBadge="name"
                :minWidth="150"
              />
            </template>
            <template slot="addColumns">
              <table-column-badges
                prop="farms[0].name"
                :label="$t('common_words.associated_farms')"
                fromData="farms"
                textBadge="name"
                :minWidth="150"
              /> </template
            ><template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
                :minWidth="100"
              /> </template
          ></master-table>
          <card-footer ref="cardfooter" :propPagination="pagination" />
        </div>
        <not-index-permissions v-else />
      </card>
      <el-dialog
        v-if="isShow()"
        :title="$t('common_words.record_selected_threepoints')"
        :visible.sync="modals.read"
        width="70%"
        top="2%"
      >
        <p>
          {{ $t('common_words.selected_record_info') }}
        </p>
        <div class="card mb-3" v-if="rowData">
          <div class="card-body">
            <payment-calendar-details-table :calendarData="rowData" />
          </div>
          <footer-date-at
            class="card-footer"
            :createdAt="rowData.created_at"
            :updatedAt="rowData.updated_at"
          />
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import configTable from 'src/views/Pages/Dashboard/PaymentCalendar/PaymentCalendarsTable.js';
import i18n from 'src/i18n';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import TableDetails from 'src/views/Pages/Dashboard/PaymentCalendar/TableDetails.vue';

export default {
  components: {
    LPagination,
    [TableDetails.name]: TableDetails,
  },
  computed: {
    ...configTable().Search,
  },
  data() {
    return {
      calendarForm: {},
      title: null,
      pagination: {},
      tableColumns: [],
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
      modals: {
        read: false,
      },
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(_, row) {
      this.rowData = row;
      this.modals['read'] = true;
    },

    handleEdit(_, row) {
      row.url_path_form = '/paymentcalendars/edit';
      this.calendarForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.calendarForm));
      this.$router.push({
        path: 'paymentcalendars/edit',
      });
    },

    handleActivate(_, row) {
      this.calendarForm = { ...row };
      SweetAlert.default(
        `¿${i18n.t('labor.activate_calendar')} "${this.calendarForm.name}"?`,
        null,
        i18n.t('sweet_alert.station.accept'),
        1
      ).then((result) => {
        if (result.value) this.activatePaymentCalendar();
      });
    },

    handleDelete(_, row) {
      this.calendarForm = { ...row };
      SweetAlert.default(
        `¿${i18n.t('labor.deactivate_calendar')} "${this.calendarForm.name}"?`,
        null,
        i18n.t('sweet_alert.station.accept'),
        1
      ).then((result) => {
        if (result.value) this.deactivatePaymentCalendar();
      });
    },

    activatePaymentCalendar() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.calendarForm.route = 'works/paymentcalendars/activate';
        Axios.updateMaster(this.calendarForm)
          .then((response) => {
            this.modifyTable(1, this.calendarForm.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    deactivatePaymentCalendar() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.calendarForm.route = 'works/paymentcalendars';
        Axios.destroyMaster(this.calendarForm)
          .then((response) => {
            this.modifyTable(1, this.calendarForm.id, response);
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      this.setupTable();
      Axios.getMasters('works/paymentcalendars')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((column) => {
              return column.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('works');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('works');
  },
};
</script>
